import { useSeo } from "../seo/useSeo";

// ページ別メタを宣言的に指定するためのコンポーネント。描画結果は持たない。
//
// 静的ルート（/news・/cases・/contact など）は App.js が siteMeta.js の
// ROUTE_META から自動で適用するため、個別に置く必要はない。
// 取得内容でタイトルが変わる詳細ページ（/news/:slug・/cases/:slug）だけ、
// 各コンポーネントからこれを描画して上書きする。
function Seo(props) {
  useSeo(props);
  return null;
}

export default Seo;
